<template>
  <div class="p-5">
    <div class="container my-3" v-if="showLogos">
      <div class="partners-grid-layout">
        <!-- Row 1 -->
        <div class="partner-cell">
          <a href="https://startupfactory.bg/en/" target="_blank">
            <img src="/static/logo/logo-sf.png" alt="Startup Factory Text" />
          </a>
        </div>
        <div class="partner-cell">
          <a href="https://spinoff.bg/" target="_blank">
            <img src="/static/logo/logo-spfbg.png" alt="SPINOFF.BG" />
          </a>
        </div>
        <div class="partner-cell">
          <a href="https://www.innovx.eu/" target="_blank">
            <img src="/static/logo/logo-innovx.png" alt="InnovX" />
          </a>
        </div>
        <div class="partner-cell">
          <a href="https://iphs.eu/en/" target="_blank">
            <img src="/static/logo/logo-iphs.png" alt="IPHS" />
          </a>
        </div>
        <div class="partner-cell">
          <a href="https://startupfactory.bg/en/" target="_blank">
            <img src="/static/logo/startupfactory.png" alt="Startup Factory" />
          </a>
        </div>

        <!-- Row 2 -->
        <div class="partner-cell">
          <a href="https://cloud.google.com/" target="_blank">
            <img src="/static/logo/Googlecloud.png" alt="Google Cloud" class="google-cloud-logo" />
          </a>
        </div>
        <div class="partner-cell">
          <a href="https://zonta-saintsofia.org/" target="_blank">
            <img src="/static/logo/logo-zonta.png" alt="Zonta" />
          </a>
        </div>
        <div class="partner-cell">
          <a href="https://analyse-yourself.com/" target="_blank">
            <img src="/static/logo/logo-analyseyourself.png" alt="Analyse Yourself" />
          </a>
        </div>
        <div class="partner-cell">
          <a href="https://framar.bg/" target="_blank">
            <img src="/static/logo/logo-framar.png" alt="Framar" />
          </a>
        </div>
        <div class="partner-cell">
          <a href="https://zdraveto.com/" target="_blank">
            <img src="/static/logo/logo-zdraveto.png" alt="Bolnitsa Zdraveto" />
          </a>
        </div>

        <!-- Row 3 -->
        <div class="partner-cell">
          <a href="https://www.ibg.bg/" target="_blank">
            <img src="/static/logo/logo-investor.png" alt="Investor" />
          </a>
        </div>
        <div class="partner-cell">
          <a href="https://www.eurocc-access.eu/" target="_blank">
            <img src="/static/logo/logo-eurocc.png" alt="EuroCC" />
          </a>
        </div>
        <div class="partner-cell">
          <a href="https://sofiatech.bg/en/" target="_blank">
            <img src="/static/logo/logo-stp.png" alt="Sofia Tech Park" />
          </a>
        </div>
        <div class="partner-cell">
          <a href="https://www.dzi.bg/" target="_blank">
            <img src="/static/logo/logo-dzi.png" alt="DZI" class="dzi-logo" />
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="wrapper">
    <div class="container">
      <div class="d-md-flex mx-5">
        <div class="logo-wrapper d-flex justify-content-center justify-content-md-start">
          <div class="logo me-md-3">
            <img src="/static/logo-sm.png" />
          </div>
          <div class="slogan my-3 my-md-0">
            <div>{{ $t('slogan-line-1') }}</div>
            <div>{{ $t('slogan-line-2') }}</div>
          </div>
        </div>
        <div class="ms-auto d-md-flex">
          <div class="contact d-flex d-md-block me-5 mt-4 mt-md-0">
            <div>{{ $t('follow-us') }}:</div>
            <div class="d-flex justify-content-between">
              <a class="px-2 px-md-0" href="https://www.facebook.com/profile.php?id=61561865897639">
                <img src="/static/fb-icon.png" alt="" />
              </a>
              <a class="px-2 px-md-0" href="https://www.instagram.com/momfident.io/">
                <img src="/static/insta-icon.png" alt="" />
              </a>
              <a class="px-2 px-md-0" href="https://www.linkedin.com/company/momfident">
                <img src="/static/linkedin-icon.png" alt="" />
              </a>
            </div>
          </div>
          <div class="contact me-5 mt-4 mt-md-0">
            <div>Tel:</div>
            <div>+359 896492133</div>
          </div>
          <div class="contact mt-4 mt-md-0">
            <div>Email:</div>
            <div>contact@momfident.io</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="wrapper-btm">
    <div class="container">
      <div class="d-flex mx-5">
        <div>{{ $t('footer-copyright') }}</div>
        <div class="ms-auto d-flex">
          <router-link :to="{name: 'tnc'}" class="me-4">{{ $t('footer-terms') }}</router-link>
          <router-link :to="{name: 'privacy-policy'}" class="me-4">{{ $t('footer-privacy') }}</router-link>
          <router-link :to="{name: 'research-references'}">{{ $t('research-references') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import defineProps from "vue";

defineProps({
  showLogos: {
    type: Boolean,
    default: true
  }
})
</script>

<style lang="scss" scoped>
.wrapper {
  color: #fff;
  background: $color-pink-dark-2;
  padding: 50px 0;
}

.wrapper-btm {
  background: #6B6B9C;
  color: #fff;
  font-size: 12px;
  padding: 20px;
}

.partners-grid-layout {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 30px;
  align-items: center;
  justify-items: center;
  width: 100%;
}

.partner-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  
  a {
    display: block;
    width: 100%;
    text-align: center;
  }

  img {
    max-width: 150px;
    max-height: 100px;
    object-fit: contain;
    transition: all 0.2s;
    
    &:hover {
      transform: scale(1.05);
    }
  }

  .bolnica-logo {
    height: 60px;
    width: auto;
  }

  .dzi-logo {
    max-height: 60px;
    max-width: 100px;
    width: auto;
    height: auto;
  }

  .google-cloud-logo {
    transform: scale(1.2);
  }
}

@media (max-width: 992px) {
  .partners-grid-layout {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 576px) {
  .partners-grid-layout {
    grid-template-columns: repeat(2, 1fr);
  }
}

.logo {
  margin: 0 30px 0 30px;
  max-width: 150px;

  img {
    max-width: 100%;
    max-height: 100px;
  }

  .bolnica-logo {
    height: 60px;
    width: auto;
  }

  .dzi-logo {
    max-height: 60px;
    max-width: 100px;
    width: auto;
    height: auto;
  }

  .google-cloud-logo {
    transform: scale(1.2);
  }

  @media (max-width: 692px) {
    margin-top: 30px;
    text-align: center;
  }

}
</style>